import useFormatCurrencyForItinerary from '@/src/hooks/currency/useFormatCurrencyForItinerary'
import { MiniRuleItem } from '@/src/types/itinerary'
import { VARIANT } from '@/src/utils/buildUtils'
import { useTranslations } from 'next-intl'
import RefundBreakup from './refundBreakup'

const RefundBreakupWrapper = ({ miniRuleData }: { miniRuleData: MiniRuleItem }) => {
    const { formatCurrency } = useFormatCurrencyForItinerary()
    const { airlineCharges, cleartripCharges, note } = miniRuleData
    const t = useTranslations('itineraryPage.miniRules')

    const variant = VARIANT.toLowerCase() as 'cleartrip' | 'flyin'
    return (
        <div>
            <RefundBreakup
                formatCurrency={formatCurrency}
                cancellationAirlineFee={airlineCharges.cancel}
                cancellationCleartripFee={cleartripCharges.cancel}
                dateChangeAirlineFee={airlineCharges.amend}
                dateChangeCleartripFee={cleartripCharges.amend}
                note={note}
                variant={variant}
                t={t}
            />
        </div>
    )
}

export default RefundBreakupWrapper
